import { Component } from "react"

class BackgroundImage extends Component{
    constructor(props){
        super(props)
        this.name = "背景画像"
    }
    validate(callbackDialog,requireCheck){
        /*if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }*/
        return true
    }
}

export default BackgroundImage;